 <template>
    <div class="a-icon">
        <component :is="`Icon${icon}`" />
    </div>
</template>

<script>
import Vue from 'vue'

const requireComponent = require.context(
    '../icons', false, /[\w]+\.vue$/
)

// register each component
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    // remove from filename './' from beginning, '.vue' at the end
    const componentName = `Icon${fileName.substr(0, fileName.length - 4).substr(2)}`
    // register component
    Vue.component(componentName, componentConfig.default || componentConfig)
})

export default {
    name: 'AIcon',
    props: {
        icon: {
            type: String,
            required: true
        }
    }
}
</script>
